const platformInfo = (state = {
  display: {
    view: null,
    appId: null,
    templateId: null,
  },
  status: {
    user: null
  },
  animateLobby: false,
}, action) => {
  switch (action.type) {
    case 'SET_DISPLAY':
      return {
        ...state,
        display: {
          ...state.display,
          ...action.display
        },
      };
    case 'RESET_DISPLAY':
      return {
        ...state,
        display: {
          view: null,
          appId: null,
          templateId: null
        },
      };
    case 'SET_USER_STATUS':
      const { user } = action;
      const {
        userApplications,
        passwordResetToken,
        refreshToken,
        userInvitationToken,
        ...remainUser
      } = user;
      return {
        ...state,
        status: {
          user: remainUser
        }
      };
    case 'UNSET_USER_STATUS':
      return {
        ...state,
        status: {
          user: null
        }
      };
    default:
      return state;
  }
};

export default platformInfo;
